"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as l } from "react/jsx-runtime";
import { useTheme as s } from "../../hooks.js";
import { useIsInverseVariant as a } from "../../theme-variant-context.js";
import { vars as r } from "../../skins/skin-contract.css-mistica.js";
const h = (_param)=>{
    var { color: i, size: c = 24 } = _param, e = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const t = a(), o = i !== null && i !== void 0 ? i : t ? r.colors.inverse : r.colors.neutralHigh, { skinName: n } = s();
    return n.match(/^o2/i) ? /* @__PURE__ */ l("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: /* @__PURE__ */ l("path", {
            fill: o,
            d: "m11.107 5.904.64-2.193c.191-.72.868-1.211 1.68-1.211.942 0 1.787.803 1.787 1.794l-.178 1.253-.89 3.046h5.711a2.15 2.15 0 0 1 1.394 3.78 2.151 2.151 0 0 1-1.188 3.313c.096.248.155.515.155.794 0 .991-.672 1.827-1.581 2.074.096.248.155.514.155.794A2.15 2.15 0 0 1 16.65 21.5h-6.077c-.854 0-1.713-.349-2.29-.927-.31-.312-.799-.505-1.279-.505H2V9.668h4.999c.192 0 .37-.074.507-.211z"
        })
    })) : /* @__PURE__ */ l("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: /* @__PURE__ */ l("path", {
            fill: o,
            d: "M21.841 10.942c0 .672-.168 1.16-.38 1.504.212.334.38.787.383 1.387 0 .658-.26 1.263-.748 1.748.126.294.221.678.221 1.168 0 .787-.411 1.468-1.148 1.93.07.347.064.74-.011 1.196q-.012.054-.031.11c-.563 1.526-1.465 1.856-5.076 1.856-2.24 0-3.2-.28-3.968-.503l-.015-.004-.21-.059c-.316-.095-.569-.165-.731-.165l-2.807-.036a.5.5 0 0 1-.13-.024l-.06-.015c-.252.21-.574.341-.927.341H3.612a1.457 1.457 0 0 1-1.457-1.456v-7.594c0-.807.653-1.46 1.457-1.46h2.585c.333 0 .639.118.885.309.55-.283 1.768-1.042 1.885-2.275.11-1.123.096-2.527.07-3.639l-.001-.02-.001-.022c-.003-.094-.01-.166-.018-.241l-.002-.016-.02-.23c-.067-.95.275-1.53.569-1.849.443-.476 1.11-.728 1.927-.728 1.566 0 2.499.95 2.499 2.535l-.003.098-.006.132c0 1.26-.002 2.787-.005 3.613l2.07.062h3.412c1.204.067 2.383.818 2.383 2.347m-1.59 1.958a.58.58 0 0 1-.191-.45c0-.175.073-.34.202-.455.235-.21.358-.574.358-1.05 0-.95-.832-1.098-1.19-1.118h-3.395l-2.687-.081a.614.614 0 0 1-.596-.616s.008-2.398.008-4.222v-.033l.006-.12c0-.975-.379-1.365-1.27-1.365-.324 0-.767.06-1.027.336-.19.205-.272.516-.244.925l.017.19.001.015c.008.079.016.156.021.249q.005.033.006.067c.025 1.157.042 2.641-.076 3.851-.173 1.818-1.781 2.858-2.54 3.25v.014l.005.042v7.52l2.476.034c.328 0 .653.093 1.062.21l.216.062.01.003c.73.212 1.558.454 3.628.454 3.44 0 3.653-.334 3.902-.998.084-.546.003-.79-.08-.94a.6.6 0 0 1-.04-.5.6.6 0 0 1 .342-.36c.414-.174.91-.5.91-1.062 0-.395-.087-.706-.255-.902a.617.617 0 0 1 .118-.908c.44-.3.664-.672.664-1.104 0-.4-.12-.717-.362-.938M4.882 14.472c.449 0 .76-.314.76-.762 0-.451-.311-.762-.76-.762-.448 0-.762.313-.762.762 0 .448.314.761.762.761"
        })
    }));
}, p = h;
export { p as default };
